<!--
 * @Description: 平安校园-培训资料 详情
 * @Author: PF
 * @Date: 2024-02-23 16:32:09
 * @LastEditors: PF
 * @LastEditTime: 2024-03-20 17:33:43
-->
<template>
  <div>
    <el-dialog class="wp80 hp85" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="4" border>
        <el-descriptions-item label="培训资料标题" label-align="right" align="left" width="150px" span="2">{{ruleForm.pxzlbt}}</el-descriptions-item>
        <el-descriptions-item label="培训资料类别" label-align="right" align="left" width="150px" span="2">{{ruleForm.pxzllbmc}}</el-descriptions-item>
        <el-descriptions-item label="培训资料格式" label-align="right" align="left" span="2">{{ruleForm.pxzlgsmc}}</el-descriptions-item>
        <el-descriptions-item label="培训资料发布时间" label-align="right" align="left" span="2">{{ruleForm.pxzlfbsj}}</el-descriptions-item>
        <el-descriptions-item label="培训资料发布范围" label-align="right" align="left" span="2">{{ruleForm.pxzlfbfwmc}}</el-descriptions-item>
        <el-descriptions-item label="培训资料可见人" label-align="right" align="left" span="2">{{ruleForm.pxzlkjr}}</el-descriptions-item>
        <el-descriptions-item label="培训资料图标" label-align="right" align="left" span="4">
          <el-image class="currentImg h200" :src="baseurl+ruleForm.pxzltb" fit="contain">
            <template #error>
              <div class="image-slot">
                <el-icon><icon-picture /></el-icon>
              </div>
            </template>
          </el-image>
        </el-descriptions-item>
        <el-descriptions-item label="培训资料" label-align="right" align="left" span="4">
          <span v-if="ruleForm.pxzlspdz" style="color: #409EFF;cursor: pointer;" @click="openFuJian=true;row={listFj:[{fj:ruleForm.pxzlspdz, ymc: ruleForm.pxzlspmc}]||[]}">预览</span>
        </el-descriptions-item>
        <el-descriptions-item label="培训资料内容" label-align="right" align="left" span="4">
          <p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.pxzlnr"></p>
        </el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="wanChengXueXi()">已学习</el-button>
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <fujian v-if="openFuJian" v-model:openDetail="openFuJian" :row="row" />
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow, actionPost } from '@/api/common.js'
import { getDate } from '@/utils/index.js'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'
import fujian from '@/components/fujian.vue'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail'])

const ruleForm = ref({})
const baseurl = ref(process.env.VUE_APP_BASE_API)// 根路径

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({
        url: '/api/v2/pinganxiaoyuan/pinganxiaoyuanpeixunziliao/' + props.row.id + '/1',
        ruleForm,
        loadSuccess: function (res) {
          ruleForm.value.pxzlkjr = res.data.listPeiXunZiLiaoQuanXianMc ? res.data.listPeiXunZiLiaoQuanXianMc.join('、') : ''
          ruleForm.value.pxzlspmc = res.data.pxzlspdz.substr(
            res.data.pxzlspdz.lastIndexOf('/') + 1
          )
        }
      })
    }
  },
  { deep: true, immediate: true }
)

// 完成学习
const wanChengXueXi = () => {
  const wcxxsj = getDate('YYYY', 'MM', 'DD', 'HH', 'mm')
  actionPost({ url: '/api/v2/pinganxiaoyuan/pinganxiaoyuanpeixunziliao/wanchengxuexi', data: { wcxxsj: wcxxsj } }).then((res) => {
    if (res.code === 200) {
      closeWindow('openDetail', emits, true)
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}


const openFuJian = ref(false)
</script>
